module.exports = __webpack_public_path__ + "img/apple-store-de-white.fb4d2fb7.svg";